// Which report types get the per-question "Question Breakdown" (what the rep
// actually said, the points hit and missed, the score per question) and
// which of those may push a question into the company's Q&A library.
//
// The breakdown was gated to Messaging Defense and Live Meeting only, so
// Objection Handling and Document Defense reps saw just the coach rows even
// though the backend stores the same per-question analysis for them (review,
// 2026-09-04; Toby: extend it). The library action stays with the two types
// whose questions are NEW to the company: Objection Handling's questions
// already ARE the library, and Document Defense questions belong to one
// document.

const BREAKDOWN_TYPES = ['Messaging Defense', 'Live Meeting', 'Objection Handling', 'Document Defense'];
const LIBRARY_SAVE_TYPES = ['Messaging Defense', 'Live Meeting'];

export const showsQuestionBreakdown = (sessionType) => BREAKDOWN_TYPES.includes(sessionType);

export const canSaveQuestionToLibrary = (sessionType) => LIBRARY_SAVE_TYPES.includes(sessionType);

// Per-question POINTS stay off the three practice types (Toby, 2026-09-30):
// the score per question read as a verdict and drew attention away from the
// covered/missed coaching. Live Meeting keeps its points. The points are still
// stored and still feed the grade band; only the badge goes.
const HIDE_POINTS_TYPES = ['Objection Handling', 'Messaging Defense', 'Document Defense'];

export const showsQuestionPoints = (sessionType) => !HIDE_POINTS_TYPES.includes(sessionType);
